import { render, staticRenderFns } from "./AccountBalanceDetailsLandlineEl.vue?vue&type=template&id=b4583182&scoped=true&"
import script from "./AccountBalanceDetailsLandlineEl.vue?vue&type=script&lang=ts&"
export * from "./AccountBalanceDetailsLandlineEl.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalanceDetailsLandlineEl.vue?vue&type=style&index=0&id=b4583182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4583182",
  null
  
)

export default component.exports